import { SxProps, Theme, Typography } from "@mui/material";
import NextLink from "next/link";
import { ElementType, ReactNode } from "react";
import { FONT_TEXT } from "@/src/components/common/broadsheet/tokens";

export default function EntryTitle({
  children,
  href,
  component = "h3",
  size = "md",
  clamp,
  sx,
}: {
  children: ReactNode;
  href: string;
  component?: ElementType;
  size?: "sm" | "md" | "lg" | "xl";
  clamp?: number;
  sx?: SxProps<Theme>;
}) {
  const fontSize = {
    sm: "0.9375rem",
    md: "1.0625rem",
    lg: "1.1875rem",
    xl: "1.5rem",
  }[size];

  return (
    <Typography
      component={component}
      sx={[
        {
          m: 0,
          fontFamily: FONT_TEXT,
          fontWeight: 700,
          fontSize,
          lineHeight: 1.28,
          "& a": {
            color: "custom.link",
            textDecoration: "none",
            "&:hover": {
              color: "custom.linkHover",
              textDecoration: "underline",
              textUnderlineOffset: "0.15em",
            },
          },
          ...(clamp
            ? {
                display: "-webkit-box",
                WebkitLineClamp: clamp,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }
            : null),
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <NextLink href={href}>{children}</NextLink>
    </Typography>
  );
}
